import {lazy} from 'react';

export const PbTableLazy = lazy(() => import(/* webpackChunkName: "pbTable" */ '.'));
